import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Tracker() {
  const loc = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    api.post("/track", { path: loc.pathname, user_id: user?.id, role: user?.role }).catch(() => {});
    // Suivi d'usage des ambassadeurs : pages consultées dans l'application
    if (user?.role === "ambassador") {
      api.post("/ambassador/track", { path: loc.pathname, title: document.title }).catch(() => {});
    }
  }, [loc.pathname, user]);
  return null;
}
